import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { GIButton } from 'app-components';
import { configs } from '@constants/configs/configs';
import { StyledIdentityHeader } from '../Layout';
import { BREAK_POINTS } from '@constants/common/breakpoints';
import { useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';

const StyledIdentityButtonContainer = styled.div`
    display: flex;
    margin-bottom: 20px;
    justify-content: space-around;
    align-items: center;
    padding-top: 20px;
    @media (max-width: ${BREAK_POINTS.sm}) {
        display: block;
        > button {
            width: 100%;
        }
    }
     .gi-button {
        background-color: ${({ theme }) => theme.primaryMain};
        
        }
    }
`;
const StyledButtonContent = styled.div`
    width: 83%;
    padding-right: 10px;
    color: ${({ theme }) => theme.gray2};
    font-size: 16px;
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

const StyledAlertContainer = styled.div`
    background: ${({ theme }) => theme.infoLightest};
    color: ${({ theme }) => theme.infoDarker};
    border-color: ${({ theme }) => theme.primaryMain};
    font-size: 16px !important;
    text-align: justify;
    border-left: ${({ theme }) => `3px solid ${theme.infoMain}`};
    padding: 8px 16px;
    border-radius: 2px;
    margin-bottom: 20px;
`;

const StyledParagraphHeader = styled.p`
    margin: 0px;
    font-weight: bold;
    color: ${({ theme }) => theme.infoDarker};
    margin-bottom: 10px;
`;
const StyledParagraphDescription = styled.p`
    color: ${({ theme }) => theme.infoDarker};
`;
const StyledParagraphUnorderedList = styled.ul`
    padding: 0px;
    margin: 0px 0px 10px 25px;
`;
const StyledListItem = styled.li`
    line-height: 20px;
`;

const GetStarted = () => {
    const {
        routes: { RIDP_CONTACT_INFO },
    } = configs;

    const navigate = useNavigate();

    const getQueryParam = (key: string) => {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get(key);
    };
    const { exchangeName } = useAppSelector(environmentSelector);
    const caseNumber = getQueryParam('caseNumber');
    const coverageYear = getQueryParam('coverageYear');
    const applicationType = getQueryParam('applicationType');

    const navigateToContactInformation = () => {
        navigate(`${RIDP_CONTACT_INFO}?coverageYear=${coverageYear}&applicationType=${applicationType}${caseNumber ? `&caseNumber=${caseNumber}` : ''}`);
    };
    return (
        <main id="main-content">
            <StyledIdentityHeader className="h4">
                <FormattedMessage id="ridp.sidebar.getStarted.header" />
            </StyledIdentityHeader>

            <StyledIdentityButtonContainer>
                <StyledButtonContent>
                    <FormattedMessage id="ridp.sidebar.getStarted.buttonContent" />
                </StyledButtonContent>
                <GIButton
                    data-testid={'ridpGetStarted'}
                    type="button"
                    id="ridpGetStarted"
                    labelId="ridp.sidebar.getStarted"
                    onClickHandler={navigateToContactInformation}
                />
            </StyledIdentityButtonContainer>
            <StyledAlertContainer>
                <StyledParagraphHeader>
                    <FormattedMessage id="ridp.sidebar.getStarted.para1.header" />
                </StyledParagraphHeader>
                <StyledParagraphDescription>
                    <FormattedMessage id="ridp.sidebar.getStarted.para1.description" values={{ exchangeName }} />
                </StyledParagraphDescription>
                <StyledParagraphHeader>
                    <FormattedMessage id="ridp.sidebar.getStarted.para2.header" />
                </StyledParagraphHeader>
                <StyledParagraphUnorderedList>
                    <StyledListItem>
                        <FormattedMessage id="ridp.sidebar.getStarted.para2.1" />
                    </StyledListItem>
                    <StyledListItem>
                        <FormattedMessage id="ridp.sidebar.getStarted.para2.2" />
                    </StyledListItem>
                    <StyledListItem>
                        <FormattedMessage id="ridp.sidebar.getStarted.para2.3" />
                    </StyledListItem>
                </StyledParagraphUnorderedList>
            </StyledAlertContainer>
        </main>
    );
};

export default GetStarted;
